<template>
    <div class="card mt-4 w-100 animated fadeInUp faster">
        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-auto"><i class="fal fa-stars text-primary fa-2x"></i></div>
                <div class="col pl-0"><h5 class="mb-0 font-weight-normal">{{ $t("creator_code.header") }}</h5></div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <div class="input-group" v-if="basket.creatorCode != '' && code == basket.creatorCode">
                        <label class="form-control text-success">Thanks for supporting {{ basket.creatorCode }}!</label>
                        <div class="input-group-append">
                            <button class="input-group-text" @click="resetCreatorCode" :disabled="loading">
                                <template>
                                    <i class="fal fa-times-circle"></i>
                                </template>
                            </button>
                        </div>
                    </div>
                    <div class="input-group" v-else>
                        <input type="text" class="form-control" v-model="code" :placeholder="$t('creator_code.form.code_placeholder')">
                        <div class="input-group-append">
                            <button class="input-group-text" @click="applyCreatorCode" :disabled="loading">
                                <template v-if="loading">
                                    <i class="fal fa-spin fa-spinner"></i>
                                </template>
                                <template v-else>
                                    {{ $t("creator_code.buttons.confirm") }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "Coupon",
        computed : {
            ...mapState({
                basket: state => state.basket
            }),
        },
        data () {
            return {
                loading: false,
                code: ''
            }
        },
        methods: {
            resetCreatorCode() {
                this.loading = true;
                this.code = '';
                this.$store.dispatch('addCreatorCode', this.code)
                    .then(() => this.loading = false)
                    .catch((error) => {
                        this.loading = false;
                        this.code = this.basket.creatorCode;
                        this.$swal({ type: 'error', text: error.response.data.message });
                });
            },
            applyCreatorCode() {
                if (!this.code) {
                    return this.$swal({ type: 'error', text: this.$t("creator_code.messages.missing_code_field") });
                }
                this.loading = true;
                this.$store.dispatch('addCreatorCode', this.code)
                     .then((response) => {
                        this.loading = false;
                        if (response && response.data && response.data.message) {
                            this.$swal({ type: 'info', text: response.data.message });
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                        this.code = this.basket.creatorCode;
                        this.$swal({ type: 'error', text: error.response.data.message });
                    });
            }
        },
        mounted() {
            this.code = this.basket.creatorCode;
        }
    }
</script>

<style scoped>

</style>
